document.addEventListener('DOMContentLoaded', () => {

	// Descriptoion Tabs
	function tabbedDescriptions() {
		const tabButtons  = document.querySelectorAll('.product-info__tab-button');
		const tabContents = document.querySelectorAll('.product-info-tab-content');

		tabButtons.forEach(button => {
			button.addEventListener('click', () => {
				// Remove 'active' class from all buttons
				tabButtons.forEach(btn => btn.classList.remove('active'));

				// Hide all tab contents
				tabContents.forEach(content => content.style.display = 'none');

				// Add 'active' class to the clicked button
				button.classList.add('active');

				// Display the corresponding tab content
				const tabId = button.getAttribute('data-tab');
				document.getElementById(tabId).style.display = 'block';

				if (tabId === 'reviews' || tabId === 'qanda') {
					// yotpoWidgetsContainer.initWidgets();
				}
			});
		});



		const yotpoLink = document.querySelector('.yotpo-reviews-star-ratings-widget');
		if (yotpoLink) {
			yotpoLink.addEventListener('click', function(e) {
				const targetChild = e.target.closest('.yotpo-sr-bottom-line-summary');

				if (targetChild) {
					// Remove 'active' class from all buttons
					tabButtons.forEach(btn => btn.classList.remove('active'));
					// Hide all tab contents
					tabContents.forEach(content => content.style.display = 'none');
					document.querySelector('.product-info__tab-button[data-tab="reviews"]').classList.add('active');
					document.getElementById('reviews').style.display = 'block';
					document.getElementById('reviews').scrollIntoView({ behavior: "smooth" });
					yotpoWidgetsContainer.initWidgets();
				}
			});
		}
	}
	tabbedDescriptions();


	// Listen for the pplrAppInitiated custom event
	window.addEventListener('pplrAppInitiated' , function(e) {
		const persTextWrap = document.querySelector('.cstmfy_personalize_text');
		const ptcButton   = document.querySelector('.ptc_button');

		if ( cstmfy_personalize_text && ptcButton ) {
			ptcButton.addEventListener('click', function() {
				// Remove all instances of the pplr-wrapper class
				// const persWrappers = persTextWrap.querySelectorAll('.pplr-wrapper');
				// persWrappers.forEach(function(persWrap) {
				// 	persWrap.classList.remove('pplr-wrapper');
				// });

				// Update form field classes
				const persLabels = persTextWrap.querySelectorAll('.pplrlabel');
				persLabels.forEach(function(persLabel) {
					persLabel.classList.add('form__label');
				});

				// Update form field classes
				const persInputs = persTextWrap.querySelectorAll('.pplr_select, .pplr_text');
				persInputs.forEach(function(persInput) {
					persInput.classList.add('form-input', 'form-input--white');
				});

			});
		}
	});


	// Update price based on quantity change
	const qtyInput = document.querySelector('.quantity__input--main');
	const priceEl = document.querySelector('.price-item--regular');

	if (!qtyInput || !priceEl) return;

	// Helper: format cents back to money with two decimals
	function formatMoney(cents) {
		// You might want your shop's currency symbol in front:
		const dollars = +(cents / 100).toFixed(2);
		const dollarsWithCommas = dollars.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
		return `$${dollarsWithCommas}`;
	}

	function updateTotalPrice() {
		const unitCents = parseInt(qtyInput.dataset.unitPrice, 10);
		const quantity  = parseInt(qtyInput.value, 10) || 1;
		const totalCents = unitCents * quantity;
		priceEl.textContent = formatMoney(totalCents);
	}

	// Run on page load in case qty !== 1
	updateTotalPrice();

	// Run whenever the quantity changes
	qtyInput.addEventListener('input', updateTotalPrice);
	qtyInput.addEventListener('change', updateTotalPrice);

});
